<template>
  <div>
    <div class="bg-white shadow-sm rounded-md h-60 overflow-x-auto">
      <div class="border-b-0.5">
        <p class="p-2 text-sm">Today at glance</p>
      </div>
      <div class="flex flex-col gap-y-1 p-2">
        <div>
          <div
            class="flex justify-between items-center p-2 border-1.5 rounded-md"
          >
            <p class="text-sm">Absent Employees</p>
            <p class="font-semibold">{{ 0 }}</p>
          </div>
        </div>
        <div>
          <div
            class="flex justify-between items-center p-2 border-1.5 rounded-md"
          >
            <p class="text-sm">Clock Ins</p>
            <p class="font-semibold">{{ 0 }}</p>
          </div>
        </div>
        <div>
          <div class="flex flex-col gap-y-1">
            <div
                :class="open == 1 ? 'border-1.5 rounded-md' : 'border-none'"
                :key="1"
            >
              <div
                  :class="open == 1 ? 'border-none' : 'border-1.5 rounded-md'"
                  @click="view(1)"
                  class="flex justify-between items-center border-1.5 p-2 rounded-md cursor-pointer"
              >
                <p class="text-sm">On leave ({{ absentCount }})</p>
                <p class="font-semibold"></p>
                <img
                    class="h-4"
                    :class="
                open == 1 ? '-rotate-0 transform' : '-rotate-90 transform'
              "
                    src="@/assets/icons/caret.png"
                />
              </div>
              <transition name="accordion">
                <div
                    v-if="open == 1"
                    class="px-1.5 p-2 "
                    style="font-size: 0.8rem !important"
                >
                  <div v-if="activeLeaveData.length > 0">
                    <div v-for="(item, index) in activeLeaveData" :key="index">
                      <p class="italic">
                        {{decryptDataLocal(item.Name, $decryptionKey)}}
                      </p>
                    </div>
                  </div>

                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchDataMixin } from "@/mixins/fetchDataMixin";
import axios from "axios";
import { mapGetters } from "vuex";
import decryptData from "@/utils/decrypt";

export default {
  name: "TodayAtGlance",
  props: [],
  mixins: [fetchDataMixin],
  data() {
    return {
      totalEmployees: null,
      absentCount: 0,
      activeLeaveData:[],
      open: null,
    };
  },
  created() {
    this.getOrganizations();
    this.getTeamLeaves();
    this.decryptDataLocal = decryptData;
  },
  watch: {
    "$data.data"(newValue, oldValue) {
      // Perform actions when the value of data changes
      oldValue;
      // Additional logic here
      this.totalEmployees = newValue.length;
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  methods: {
    view(index) {
      if (index == this.open) {
        this.open = null;
      } else {
        this.open = index;
      }
    },
    // /{organization}/employee/all/v1/request
    getOrganizations() {
      const url = `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      this.fetchData(url, options);
    },

    getTeamLeaves() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/timeoff/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit("closeOnSuccess");

              // Create an object to store unique items based on Id
              const uniqueItems = {};

              // Filter and keep only unique items based on Id
              response.data.Data.forEach((item) => {
                uniqueItems[item.Id] = item;
              });

              // Convert the object back to an array of objects
              this.tableData = Object.values(uniqueItems).filter(
                (d) => d.LeaveType !== "Test"
              );
              this.tableData = this.tableData.filter(
                (d) => d.Status === "Approved"
              );
              axios.get(
                  `${this.getOrganization}/timeoff/active/${this.$ApiVersion}/request`,
                  options
              ).then((response)=>{
                    if (response.status === 200){
                      this.activeLeaveData = response.data.Data
                      this.getNumberOfAbscentEmployees(this.activeLeaveData);
                    }
                  },
                  (error) => {
                    this.get_error = error.message;
                  })

            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getNumberOfAbscentEmployees(data) {
      this.absentCount = data.length
    },
  },
};
</script>
